
import { useState, useCallback } from 'react';
import { toast } from '@/components/ui/sonner';
import { proxyFetch } from '@/utils/proxy';
import { getGeocodingApiUrl } from '@/hooks/googleMap/config';

/**
 * Хук для использования Google Geocoding API с поддержкой проксирования
 */
export const useGoogleGeocoding = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [address, setAddress] = useState<string | null>(null);

  /**
   * Получение адреса по координатам через Google Geocoding API
   */
  const getAddressFromCoords = useCallback(async (latitude: number, longitude: number): Promise<string | null> => {
    setLoading(true);
    setError(null);
    
    try {
      console.log('Запрос адреса по координатам:', latitude, longitude);
      
      // Используем новую функцию для получения URL с поддержкой прокси
      const url = getGeocodingApiUrl(latitude, longitude);
      
      // Используем proxyFetch для запроса с автоматическим проксированием
      const result = await proxyFetch(url, {
        service: 'geocoding',
        timeout: 15000
      });
      
      if (result.ok && result.data) {
        console.log('Google API вернул статус:', result.data.status);
        
        if (result.data.status === 'OK' && result.data.results && result.data.results.length > 0) {
          const newAddress = result.data.results[0].formatted_address;
          console.log('Получен адрес:', newAddress);
          setAddress(newAddress);
          return newAddress;
        } else {
          console.error('Не удалось получить адрес:', result.data.status);
          setError(`Не удалось получить адрес: ${result.data.status || 'неизвестная ошибка'}`);
          return null;
        }
      } else {
        console.error('Ошибка геокодирования:', result.error);
        setError(result.error || 'Неизвестная ошибка');
        toast.error('Не удалось определить адрес');
        return null;
      }
    } catch (err) {
      console.error('Ошибка геокодирования:', err);
      setError(err instanceof Error ? err.message : 'Неизвестная ошибка');
      toast.error('Не удалось определить адрес');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    error,
    address,
    getAddressFromCoords
  };
};
